'use strict';

/**
 * Toggle Carousel Controls(Prev and Next buttons) display
 * @param {Object} $carousel carousel element - jquery object
 */
function toggleCarouselControls($carousel) {
    if ($carousel.length) {
        var $carouselInner = $carousel.find('.carousel-inner');
        var totalSlides = $carouselInner.length ? $carouselInner.children('.carousel-item').length : 0;
        var activeIndex = $carouselInner.find('.carousel-item.active').index();
        var isFirstCarouselItem = activeIndex === 0;
        if (isFirstCarouselItem) {
            $carousel.find('.carousel-control-next').removeClass('d-none');
            $carousel.find('.carousel-control-prev').addClass('d-none');
        } else if (activeIndex === (totalSlides - 1)) {
            $carousel.find('.carousel-control-prev').removeClass('d-none');
            $carousel.find('.carousel-control-next').addClass('d-none');
        } else {
            $carousel.find('.carousel-control-prev').removeClass('d-none');
            $carousel.find('.carousel-control-next').removeClass('d-none');
        }
    }
}

/**
 * Toggle Carousel Controls(Prev and Next buttons) display for the PDP only
 * New function created to accommodate the expansion to RTL sites without affecting non-PDP carousels
 * The PDP carousel, to account for disabled mobile swiping, is instead showing/hiding the controls that would normally only be present on the zoom modal
 * @param {Object} $carousel carousel element - jquery object
 * @param {string} carouselInnerClass selector for the carousel inner element (should be a valid jQuery selector string, e.g., '.carousel-inner')
 * @returns {void}
 */
function togglePDPCarouselControls($carousel, carouselInnerClass) {
    // Guard: No carousel found, exit early
    if (!$carousel.length) return;

    const $carouselInner = $carousel.find(carouselInnerClass);
    // Guard: No carousel inner element, exit early
    if (!$carouselInner.length) return;

    const activeIndex = $carouselInner.find('.carousel-item.active').index();

    // Guard: No active carousel item, exit early
    if (activeIndex === -1) return;

    // Get total slides from data attribute, default to 0 if not found or invalid
    const totalSlides = parseInt($carousel.data('slide-count'), 10) || 0;

    // First slide is active
    if (activeIndex === 0) {
        $carousel.find('.carousel-control-next').removeClass('d-none');
        $carousel.find('.carousel-control-prev').addClass('d-none');
    // Last slide is active
    } else if (activeIndex === (totalSlides - 1)) {
        $carousel.find('.carousel-control-prev').removeClass('d-none');
        $carousel.find('.carousel-control-next').addClass('d-none');
    } else {
        $carousel.find('.carousel-control-prev').removeClass('d-none');
        $carousel.find('.carousel-control-next').removeClass('d-none');
    }
}

module.exports = {
    toggleCarouselControls: toggleCarouselControls,
    togglePDPCarouselControls: togglePDPCarouselControls
};
